import { SearchOutlined } from '@ant-design/icons';
import Popup from '@root/core/components/Popup';
import useDebounce from '@root/core/hooks/useDebounce';
import ReturnServices from '@root/modules/Sellers/Return/services/return';
import DetailsPro from '@root/modules/Warehouse/Inquiry/components/details-pro';
import { AutoComplete, Form, message, Spin } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Recipient from '../components/Recipient/Recipient';

interface Props {
  tab?: string;
}

const CancelStock = ({ tab }: Props) => {
  const [openReject, setOpenReject] = useState(false);
  const [openApprove, setOpenApprove] = useState(false);
  const [value, setValue] = useState('');
  const [options, setOptions] = useState<{ value: string; id: Number }[]>([]);
  const [showAdd, setShowAdd] = useState(false);
  const debounc = useDebounce(value, 1000);
  const [listStock, setListStock] = useState({} as any);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [productId, setProductId] = useState(0);
  const [valueSearch, setValueSearch] = useState('');
  const [getBody, setGetBody] = useState<any>();
  const [destroy, setDestroy] = useState('');
  const [dataSearch, setDataSearch] = useState([] as any);

  /*------------------------search----------------------------------*/

  const onSearch = async (searchText: any) => {
    setOptions([]);
    const listId = await ReturnServices.searchStock(searchText);
    if (listId) {
      let a = listId.data.map((item: any, index: number) => {
        console.log('item', item);
        return {
          value: item.productName,
          key: item.id,
          warehouseName: item.warehouse.name,
          label: (
            <div
              key={index + 200}
              onClick={() => {
                onSelect(item.id);
                setProductId(item.id);
                setDataSearch(item.warehouse.name);
              }}
            >
              {item.productName} {`(${item.warehouse.name})`}
            </div>
          )
        };
      });
      setOptions(listId.data.length > 0 ? a : []);
    }
  };

  useEffect(() => {
    onSearch(value);
  }, [debounc]);

  const onChange = async (data: string) => {
    setValue(data);
    if (!data) {
      setShowAdd(false);
    }
  };

  const onSelect = async (id: number) => {
    if (id !== 0) {
      const quoteDetail = await ReturnServices.getListStockProduct(id);
      setListStock(quoteDetail.data);
    }
  };

  const handleChangeValue = (e: any) => {
    setValueSearch(e);
    if (e.length === 0) {
      setDataSearch('');
    }
  };

  useEffect(() => {
    let locat: any = history.location.state;
    if (!!locat && !!locat.idStock) {
      onSelect(Number(locat?.idStock));
      setValueSearch(locat.stockName);
      setOptions([]);
      setProductId(Number(locat?.idStock));
    }
  }, [history]);
  /*---------------------------------------return--------------------------*/
  const [idPros, setIdPros] = useState([] as any);
  // const [shippAdd, setShippAdd] = useState([] as any);

  // useEffect(() => {
  //   setShippAdd('');
  // }, [shippAdd]);

  const childRef: any = useRef();

  /*---get checkbox----*/
  const onChangeCheck = (checkedValues: CheckboxValueType[]) => {
    const list: any[] = [];
    list.push({ checkedValues });
    setIdPros(list);
  };

  /*---------------handel ok-------------------*/

  const handleOKReturn = async () => {
    setOpenReject(false);
    setOpenApprove(false);
    setLoading(true);

    try {
      const quoteDetail = await ReturnServices.postCreateOrder(getBody);
      setLoading(false);
      if (quoteDetail.massage === 'success') {
        message.success(
          getBody.processType === 'return'
            ? 'Add return order stock success!'
            : 'Add return disposal stock success!'
        );

        history.push(
          getBody.processType === 'return'
            ? '/admin/seller/return'
            : '/admin/seller/return-disposal'
        );
      }
    } catch (err) {
      setLoading(false);
      message.error(
        getBody.processType === 'return'
          ? 'Cant add return order stock !'
          : 'Cant add return disposal stock !'
      );
    }
  };

  console.log('listStock', listStock);
  
  return (
    <div className="requestStock">
      <Spin spinning={loading}>
        <div className="searchNumber">
          <p>Product Name</p>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <Form.Item className="searchOrder" name="orderNumber">
              <AutoComplete
                value={valueSearch}
                options={options}
                // onSearch={onSearch}
                onSearch={onChange}
                onChange={handleChangeValue}
              ></AutoComplete>
              <SearchOutlined />
            </Form.Item>

            <p className="statusDe">
              {/* <div className="warehouse-name">Warehouse Name:{dataSearch}</div> */}
              <span>
                잔여 수량 :
                {listStock
                  ? listStock?.inventory === null
                    ? 0
                    : listStock?.inventory?.remainQuantity
                  : 0}
              </span>
            </p>
          </div>
        </div>
        <div
          style={{
            borderTop: '1px solid #ebecef',
            padding: '20px 0px',
            borderBottom: '1px solid #ebecef'
          }}
        >
          {/* {dataSearch ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end',
                paddingBottom: '2%'
              }}
              className="warehouse-name"
            >
              Warehouse-Name: {dataSearch}
            </div>
          ) : (
            ''
          )} */}

          <DetailsPro
            id={listStock?.id}
            img={listStock?.image?.url}
            productName={listStock?.productName}
            width={listStock?.width}
            height={listStock?.height}
            length={listStock?.length}
            demensionUnit={listStock?.demensionUnit}
            weight={listStock?.weight}
            weightUnit={listStock?.weightUnit}
            estimateQuantity={listStock?.estimateQuantity}
            averageMonthSale={listStock?.averageMonthSale}
            sku={listStock?.sku}
            eanUpc={listStock?.eanUpc}
            asin={listStock?.asin}
            packedMethod={listStock?.packedMethod}
            storageMethod={listStock?.storageMethod}
            dangerousGoods={listStock?.dangerousGoods === 'true' ? 'Yes' : 'No'}
            lotProduct={listStock?.lotProduct}
          />
        </div>
        <Recipient
          nothaveBtn
          isCancelBtn={true}
          canEdit
          ref={childRef}
          haveOneQuan
          entityId={productId}
          getBody={setGetBody}
          tab={tab}
          setOpenReject={setOpenReject}
          setOpenApprove={setOpenApprove}
          setDestroy={setDestroy}
          RequestTitle='반환요청'
          quantityStock={listStock?.inventory?.remainQuantity}
          recipientName={listStock?.warehouse?.name}
          recipientPhone={listStock?.warehouse?.phoneNumber}
          state={listStock?.warehouse?.state}
          postalCode={listStock?.warehouse?.postalCode}
          country={listStock?.warehouse?.country}
          city={listStock?.warehouse?.city}
          detailReturnAddress={listStock?.warehouse?.detailAddress}
          detailReturnAddress2={listStock?.warehouse?.detailAddress2}
        />
      </Spin>
      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={openReject}
        textCancel="취소"
        textOk="확인"
        title="반송 요청 하시겠습니까?"
        action_oke={handleOKReturn}
        action_cancel={() => {
          setOpenReject(false);
          // history.push('/admin/seller/return');
        }}
      />
      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={openApprove}
        textCancel="취소"
        textOk="확인"
        title="폐기 요청 하시겠습니까?"
        action_oke={handleOKReturn}
        action_cancel={() => {
          setOpenApprove(false);
          // history.push('/admin/seller/return-disposal');
        }}
      />
    </div>
  );
};

export default CancelStock;
